// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLink_root__jq_v8","small":"ButtonLink_small__n4gqf"};